"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var querystring_1 = __importDefault(require("querystring"));
var debounce_1 = __importDefault(require("lodash/debounce"));
var BaseLayout_1 = __importDefault(require("../app/components/BaseLayout"));
var appMargins_1 = __importDefault(require("../app/components/AppMargins/appMargins"));
var actions_1 = __importDefault(require("./actions"));
var types_1 = require("../app/util/types");
var indexGroupUrl_1 = __importDefault(require("../directory/components/DirectoryHeader/indexGroupUrl"));
var indexGroupUrl_2 = __importDefault(require("../directory/components/DirectoryResults/indexGroupUrl"));
var EmptySearchGraphic_1 = __importDefault(require("../directory/components/EmptySearchGraphic"));
// import { GAEvent, GAPageView } from '../app/util/ga'
var constants_1 = require("../directory/constants");
var useStyles = core_1.makeStyles(function () {
    return core_1.createStyles({
        root: {
            height: '100vh',
            overflowY: 'auto',
            zIndex: 1,
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            flexShrink: 0,
            '-ms-flex': '1 1 auto',
        },
    });
});
/**
 * Search query default parameters.
 */
var defaultParams = {
    query: '',
    sortOrder: constants_1.defaultSortOption,
    rowsPerPage: 10,
    currentPage: 0,
    state: '',
    isFile: '',
    isEmail: 'false',
    isTag: 'false',
    isDomain: 'false',
    domain: '',
};
/**
 * Redirect back to directory page with parameters that are different from default parameters.
 */
var redirectWithParams = function (newParams, history, paramUrl) {
    var queryObject = { query: newParams.query };
    Object.entries(newParams).map(function (_a, _) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        if (value && value !== defaultParams[key]) {
            queryObject[key] = value;
        }
        return;
    });
    var newPath = {
        pathname: types_1.GROUP_URL + "/" + (paramUrl.groupUrl || ''),
        search: "" + querystring_1.default.stringify(queryObject),
    };
    history.push(newPath);
};
var updateQueryDebounced = debounce_1.default(redirectWithParams, 500);
/**
 * @component Directory page root component.
 */
var GroupUrlPage = function () {
    var appMargins = appMargins_1.default();
    var classes = useStyles({ appMargins: appMargins });
    var dispatch = react_redux_1.useDispatch();
    var history = react_router_dom_1.useHistory();
    var location = react_router_dom_1.useLocation();
    var paramUrl = react_router_dom_1.useParams();
    var _a = __read(react_1.useState(''), 2), pendingQuery = _a[0], setPendingQuery = _a[1];
    var _b = __read(react_1.useState(false), 2), isDisplayQueryResult = _b[0], setIsDisplayQueryResult = _b[1];
    var _c = __read(react_1.useState(defaultParams.isFile), 2), queryFile = _c[0], setQueryFile = _c[1];
    var _d = __read(react_1.useState(defaultParams.state), 2), querystate = _d[0], setQueryState = _d[1];
    var _e = __read(react_1.useState(defaultParams.isEmail), 2), queryEmail = _e[0], setQueryEmail = _e[1];
    var _f = __read(react_1.useState(defaultParams.isTag), 2), queryTag = _f[0], setQueryTag = _f[1];
    var _g = __read(react_1.useState(defaultParams.isDomain), 2), queryIsDomain = _g[0], setQueryIsDomain = _g[1];
    var _h = __read(react_1.useState(defaultParams.domain), 2), queryDomain = _h[0], setQueryDomain = _h[1];
    var _j = __read(react_1.useState(defaultParams.sortOrder), 2), queryOrder = _j[0], setQueryOrder = _j[1];
    var _k = __read(react_1.useState(false), 2), disablePagination = _k[0], setDisablePagination = _k[1];
    /**
     * Search parameters that includes the latest changes and retain default values for the others.
     */
    var urlParams = querystring_1.default.parse(location.search.substring(1));
    var params = __assign(__assign({}, defaultParams), urlParams);
    var query = params.query, sortOrder = params.sortOrder, state = params.state, isFile = params.isFile, isEmail = params.isEmail, isTag = params.isTag, isDomain = params.isDomain, domain = params.domain;
    var rowsPerPage = Number(params.rowsPerPage);
    var currentPage = Number(params.currentPage);
    var rankOffset = rowsPerPage * currentPage;
    /** Dispatch action to get new results. */
    var getResults = function () {
        return dispatch(actions_1.default.getDirectoryResults(query, sortOrder, rowsPerPage, currentPage, state, isFile, isEmail, isTag, isDomain, isDomain === 'true' ? domain : '', paramUrl));
    };
    var resultsCount = react_redux_1.useSelector(function (state) { return state.directory.resultsCount; });
    var queryForResult = react_redux_1.useSelector(function (state) { return state.directory.queryForResult; });
    var searchResults = react_redux_1.useSelector(function (state) { return state.directory.results; });
    var pageCount = Math.ceil(resultsCount / rowsPerPage);
    var onQueryChange = function (newQuery) {
        setPendingQuery(newQuery);
        updateQueryDebounced(__assign(__assign({}, params), { query: newQuery, state: querystate, isFile: queryFile, isEmail: queryEmail, isTag: queryTag, isDomain: queryIsDomain, domain: queryDomain, sortOrder: queryOrder, currentPage: newQuery === params.query
                ? params.currentPage
                : defaultParams.currentPage }), history, paramUrl);
    };
    /** Redirect when sort order, type or state changes. */
    var applyChanges = function () {
        if (!(queryFile === params.isFile) ||
            !(querystate === params.state) ||
            !(queryOrder === params.sortOrder)) {
            redirectWithParams(__assign(__assign({}, params), { state: querystate, isFile: queryFile, sortOrder: queryOrder, isEmail: queryEmail, isTag: queryTag, isDomain: queryIsDomain, domain: queryDomain, currentPage: defaultParams.currentPage }), history, paramUrl);
        }
    };
    /** Reset all parameters to default. */
    var onResetFilter = function () {
        // Ensure same differences will not be pushed to history
        if (!(queryFile === defaultParams.isFile) ||
            !(querystate === defaultParams.state) ||
            !(queryOrder === defaultParams.sortOrder)) {
            redirectWithParams(__assign(__assign({}, defaultParams), { query: query, isEmail: queryEmail, isTag: queryTag, isDomain: queryIsDomain }), history, paramUrl);
        }
    };
    // Redirect when queryEmail and queryTag changes
    react_1.useEffect(function () {
        if (queryIsDomain === 'false') {
            setQueryDomain('');
        }
        setPendingQuery('');
        dispatch(actions_1.default.resetDirectoryResults());
        redirectWithParams(__assign(__assign({}, defaultParams), { state: querystate, isFile: queryFile, sortOrder: queryOrder, isEmail: queryEmail, isTag: queryTag, isDomain: queryIsDomain, domain: queryDomain }), history, paramUrl);
    }, [queryEmail, queryTag, queryIsDomain]);
    var onClearQuery = function () {
        setPendingQuery('');
    };
    /** Redirect when page number changes. */
    var changePageHandler = function (_, pageNumber) {
        redirectWithParams(__assign(__assign({}, params), { state: querystate, isFile: queryFile, sortOrder: queryOrder, isEmail: queryEmail, isDomain: queryIsDomain, domain: queryDomain, currentPage: pageNumber }), history, paramUrl);
    };
    /** Redirect when rows per page changes. */
    var changeRowsPerPageHandler = function (event) {
        redirectWithParams(__assign(__assign({}, params), { state: querystate, isFile: queryFile, sortOrder: queryOrder, isEmail: queryEmail, isDomain: queryIsDomain, domain: queryDomain, currentPage: 0, rowsPerPage: parseInt(event.target.value, 10) }), history, paramUrl);
    };
    var queryToDisplay = (queryForResult || '').trim();
    // detect changes in query
    react_1.useEffect(function () {
        // if (isDomain === 'false' && !query) {
        //   return
        // }
        setPendingQuery(query);
        getResults();
    }, [
        query,
        sortOrder,
        rowsPerPage,
        currentPage,
        state,
        isFile,
        isEmail,
        domain,
        isDomain,
    ]);
    react_1.useEffect(function () {
        if (isDomain === 'false')
            return;
        updateQueryDebounced(__assign(__assign({}, params), { query: query, state: querystate, isFile: queryFile, isEmail: queryEmail, isTag: queryTag, isDomain: queryIsDomain, domain: queryDomain, sortOrder: queryOrder }), history, paramUrl);
    }, [queryDomain]);
    react_1.useEffect(function () {
        var queryResult = (queryForResult || '').trim();
        if (paramUrl) {
            if (searchResults.length > 0) {
                setIsDisplayQueryResult(true);
            }
            else {
                setIsDisplayQueryResult(!!queryResult);
            }
        }
        else {
            setIsDisplayQueryResult(!!queryResult);
        }
    }, [searchResults, queryForResult]);
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement(BaseLayout_1.default, null,
            react_1.default.createElement(indexGroupUrl_1.default, { hideFilter: true, hideStatusFilter: true, onQueryChange: onQueryChange, query: pendingQuery, onSortOrderChange: setQueryOrder, onClearQuery: onClearQuery, getFile: setQueryFile, getState: setQueryState, getEmail: setQueryEmail, getTag: setQueryTag, getDomain: setQueryIsDomain, onApply: applyChanges, onReset: onResetFilter, setDisablePagination: setDisablePagination }),
            isDisplayQueryResult ? (react_1.default.createElement(indexGroupUrl_2.default, { searchResults: searchResults, pageCount: pageCount, rowsPerPage: rowsPerPage, currentPage: currentPage, changePageHandler: changePageHandler, changeRowsPerPageHandler: changeRowsPerPageHandler, resultsCount: resultsCount, query: queryToDisplay, disablePagination: disablePagination, rankOffset: rankOffset })) : (react_1.default.createElement(EmptySearchGraphic_1.default, null)))));
};
exports.default = GroupUrlPage;
